module.exports = __webpack_public_path__ + "static/img/shl_news_center_latest_selected.a055703.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_news_center_latest_selected.png
// module id = XGkF
// module chunks = 5